export const DESKTOP_APP_URI_PREFIX = "desktopapp://";
